import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-semibold transition-[background,color,border-color,box-shadow] duration-150 cursor-pointer disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 ring-ring/10 dark:ring-ring/20 dark:outline-ring/40 outline-ring/50 focus-visible:ring-4 focus-visible:outline-1 aria-invalid:focus-visible:ring-0",
  {
    variants: {
      variant: {
        default:
          "border border-action-border bg-action text-action-foreground shadow-sm hover:bg-action-hover hover:shadow-md active:bg-action-active",
        destructive:
          "border border-destructive bg-destructive text-destructive-foreground shadow-sm hover:bg-[color-mix(in_srgb,var(--destructive),#0a0f1a_8%)]",
        outline:
          "border border-input bg-background text-foreground shadow-sm hover:border-primary/50 hover:bg-accent/40",
        secondary:
          "border border-secondary bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90",
        ghost:
          "hover:bg-accent hover:text-accent-foreground active:bg-accent active:text-accent-foreground",
        link: "text-brand-ink underline-offset-4 hover:underline disabled:bg-transparent",
      },
      size: {
        lg: "w-full h-12 px-4 py-2.5 text-sm",
        default: "w-full h-10 px-4 py-2.5 text-sm",
        sm: "w-full h-9 px-3 py-2 text-sm",
        icon: "size-9 rounded-md",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
